import { Box, Card, CardContent, Typography } from "@mui/material";
import { TooltipProps } from "recharts";
import { NameType, ValueType } from "recharts/types/component/DefaultTooltipContent";

const CustomTooltip = ({
    active,
    payload,
    label,
}: TooltipProps<ValueType, NameType>) => {
    if (active) {
        return (
            <Card
                sx={{
                    maxWidth: '300px'
                }}
            >
                <CardContent>
                    <Typography 
                        gutterBottom 
                        variant="h5" 
                        component="div"
                        sx={{
                            color: 'black'
                        }}
                    >
                        {label}
                    </Typography>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column'
                        }}
                    >
                        {
                            payload?.map((item) => {
                                return (
                                    <Box
                                        key={`${item.name}-${item.value}`}
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            gap: '5px',
                                            justifyContent: 'flex-start'
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: '20px',
                                                height: '10px',
                                                backgroundColor: item?.color,
                                                border: `1px solid ${item?.stroke}`
                                            }}
                                        />
                                        <Typography 
                                            variant="body2" 
                                            sx={{ 
                                                color: 'text.secondary',
                                                fontSize: '0.8rem'
                                            }}
                                        >
                                            {item?.name}: {item?.value}
                                        </Typography>
                                    </Box>
                                );
                            })
                        }
                    </Box>
                </CardContent>
            </Card>
        );
    }

    return null;
};

export default CustomTooltip;